/**
 * The client-side mirror of the DB's place-location inheritance rule
 * (`place_inherit_from_parent()`, migration 20260819150000).
 *
 * Since that migration a child's location is a **default, not a lock**: a place
 * saved without an address takes its parent's, a place saved *with* one keeps
 * it, and clearing it back to NULL re-inherits. The UI has to render which of
 * those two states a place is in, and neither side records whether a value was
 * set deliberately — so "inheriting" is inferred exactly the way the trigger
 * infers it: the child holds nothing, or holds precisely what the parent holds.
 *
 * A child that happens to sit at its parent's address is therefore treated as
 * inheriting. That is deliberate and harmless: it moves with the parent, which
 * is what the database would do to it anyway.
 */
export function placeInheritsParentAddress(
  /** The place's own `gis_location_id` as the form currently holds it. */
  currentLocationId: string | null | undefined,
  /** The chosen parent, or null/undefined for a root place. */
  parent: { gis_location_id: string | null } | null | undefined,
): boolean {
  if (!parent) return false;
  return currentLocationId == null || currentLocationId === parent.gis_location_id;
}
